"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iMail = exports.iCreateMail = exports.iMailAttacment = void 0;
const t = require("io-ts");
const user_1 = require("./user");
const file_1 = require("./file");
exports.iMailAttacment = t.interface({});
const _iCreateMail = t.intersection([
    t.interface({
        from: t.union([user_1.iAuthor, user_1.iUser]),
        to: t.string,
        subject: t.string,
        message: t.string
    }),
    t.partial({
        bcc: t.string,
        attachmentFolder: t.number,
        attachments: t.array(file_1.iRevisionOrFolder)
    })
]);
exports.iCreateMail = t.clean(_iCreateMail);
const _iMail = t.intersection([
    t.interface({
        id: t.number,
        from: user_1.iAuthor,
        to: t.string,
        subject: t.string,
        message: t.string,
        createdAt: t.number
    }),
    t.partial({
        bcc: t.string,
        attachmentFolder: t.number
    })
]);
exports.iMail = t.clean(_iMail);
//# sourceMappingURL=mail.js.map